<template>
    <div class="profiles apprentice-simple-card remove-bottom-card-margin">
        <div class="component-title">
            <h5 class="title">{{ $t('profile.students') }}</h5>
        </div>

        <design-2021-apprentice-data-table
            class="profiles-apprentice-table"
            :items="studentsTableData"
            :fields="studentFields"
            :sort-compare="sortCompare"
            :show-empty="true">
            <template #options>
                <!--                <div class="profile-filter">-->
                <design-2021-profiles-show-filters-component
                    v-if="groups.length || lasGroups.length || lasMainGroups.length"
                    :groups-in="groups"
                    :las-groups-in="lasGroups"
                    :las-main-groups-in="lasMainGroups"
                    @update-group-type="updateSelectedType"
                    @update-las-group="updateSelectedLasGroup"
                    @update-projects="updateSelectedProjectsGroup">
                </design-2021-profiles-show-filters-component>
                <!--                </div>-->
            </template>

            <template v-slot:cell(actions)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-user-circle btn-open-group"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('profile.profile')"
                        @click="goToProfile(data.item.id)">
                    </b-button>

                    <b-button
                        class="btn-eye btn-open-group"
                        v-if="$authUser.isAdmin()"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('profile.take_over_account')"
                        @click="takeOverProfile(data.item.id)">
                    </b-button>

                    <b-button
                        class="btn-user-chart btn-open-cohorts"
                        v-b-tooltip="`${sluSchoolSettings.module_name}`"
                        v-if="hasBeenAssignedToCohorts(data.item)"
                        variant="primary-icon-only"
                        @click="goToCohortsPage(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(profile_cards_count)="data">
                {{ data.item.profile_cards_count }}
            </template>

            <template v-slot:cell(profile_card_latest_updated)="data">
                <div v-if="data.item.profile_card_latest_updated">
                    {{ data.item.profile_card_latest_updated.date | date_named_month }}
                </div>
            </template>

            <template v-slot:cell(personal_goal)="data">
                <div class="personal-goal-statuses">
                    <b-progress
                        class="personal-goal-status-progress"
                        :max="data.item.personal_goal_total"
                        show-value>
                        <b-progress-bar
                            v-for="(status, index) in data.item.personal_goal_statuses"
                            v-b-tooltip.hover
                            :variant="index"
                            :value="status"
                            :key="index"
                            :title="toolTipLabel(status, index)">
                        </b-progress-bar>
                    </b-progress>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header empty-profile-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('profile.no_students_found_for_the_current_selection') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'design-2021-profiles-component',
    props: ['students', 'lasGroups', 'lasMainGroups', 'groups', 'sluCohortsIn', 'sluSchoolSettings', 'personalGoals'],
    data() {
        return {
            studentFields: [
                { key: 'full_name', label: this.$t('profile.student'), sortable: true },
                {
                    key: 'profile_cards_count',
                    label: this.$t('profile.number_of_timeline_items'),
                    sortable: true,
                    type: 'count',
                },
                {
                    key: 'profile_card_latest_updated',
                    label: this.$t('profile.timeline_last_updated'),
                    sortable: true,
                    type: 'date',
                },
                { key: 'personal_goal', label: this.$t('common.learning_goals'), sortable: false },
                { key: 'actions', label: this.$t('common.actions'), sortable: false },
            ],
            groupType: 0,
            mainGroup: null,
            projectsGroup: 0,
        };
    },

    methods: {
        goToProfile(user_id) {
            window.location.href = this.routes.profileTeacherAccess(user_id);
        },

        takeOverProfile(user_id) {
            window.location.href = this.routes.schoolSelectUser(user_id);
        },

        updateSelectedType(selectedType) {
            this.groupType = selectedType;
            this.mainGroup = null;
        },

        updateSelectedLasGroup(selectedGroup) {
            this.mainGroup = selectedGroup;
        },

        updateSelectedProjectsGroup(selected) {
            this.projectsGroup = selected;
        },

        sortCompare(firstRow, secondRow, key) {
            if (key === 'profile_card_latest_updated' && firstRow[key] && secondRow[key]) {
                const firstDate = moment(firstRow[key].date).format('YYYY-MM-DD');
                const secondDate = moment(secondRow[key].date).format('YYYY-MM-DD');

                return firstDate < secondDate ? -1 : firstDate > secondDate ? 1 : 0;
            } else if (key === 'full_name' && firstRow[key] && secondRow[key]) {
                const firstName = String(firstRow.surname).toLowerCase();
                const secondName = String(secondRow.surname).toLowerCase();

                return firstName < secondName ? -1 : firstName > secondName ? 1 : 0;
            } else {
                return false;
            }
        },

        toolTipLabel(number, label) {
            if (label === 'closed') return `${number} ${this.$t('profile.completed')}`;
            if (label === 'open') return `${number} ${this.$t('common.open')}`;
        },

        hasBeenAssignedToCohorts(rowData) {
            if (this.sluCohortsIn.length > 0) {
                for (const cohort of this.sluCohortsIn) {
                    if (cohort.users.length > 0) {
                        if (cohort.users.find((user) => user.id === rowData.id)) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },

        goToCohortsPage(userId) {
            window.location.href = this.routes.sluStudentBoard(userId);
        },
    },
    computed: {
        studentsTableData() {
            let students = this.students;

            for (let i = 0; i < students.length; i++) {
                const goals = this.personalGoals.filter((goal) => goal.user_id === students[i].id);

                if (goals.length === 0) {
                    continue;
                }

                students[i].personal_goal_statuses = {};
                students[i].personal_goal_total = goals.length;
                let open = 0;
                let closed = 0;
                for (let needle = 0; needle < goals.length; needle++) {
                    let checked = 0;

                    if (goals[needle].tasks.length > 0) {
                        let statusesIds = goals[needle].tasks.map((task) => task.checked);
                        if (statusesIds.indexOf(0) === -1) {
                            closed++;
                        } else {
                            open++;
                        }
                    } else {
                        open++;
                    }
                }

                if (open > 0) {
                    students[i].personal_goal_statuses.open = open;
                }

                if (closed > 0) {
                    students[i].personal_goal_statuses.closed = closed;
                }
            }

            // Projects
            if (this.groupType === 1) {
                if (this.projectsGroup === 0) {
                    return students.filter((student) => {
                        if (student.group_ids.length) {
                            return true;
                        }
                    });
                } else {
                    return students.filter((student) => {
                        for (const group of student.group_ids) {
                            if (group === this.projectsGroup) {
                                return true;
                            }
                        }
                    });
                }
            }

            // LASGroups
            if (this.groupType === 2) {
                if (this.mainGroup === null) {
                    return students.filter((student) => {
                        for (const lasGroup of student.las_group_ids) {
                            LasGroups: for (const las of this.lasGroups) {
                                if (las.id === lasGroup) {
                                    return true;
                                    break LasGroups;
                                }
                            }
                        }
                    });
                } else {
                    return students.filter((student) => {
                        for (const group of student.las_group_ids) {
                            if (group === this.mainGroup) {
                                return true;
                            }
                        }
                    });
                }
            }

            // LASMainGroups
            if (this.groupType === 3) {
                if (this.mainGroup === null) {
                    return students.filter((student) => {
                        for (const lasMainGroup of student.las_main_group_ids) {
                            lasMainGroups: for (const lasMain of this.lasMainGroups) {
                                if (lasMain.id === lasMainGroup) {
                                    return true;
                                    break lasMainGroups;
                                }
                            }
                        }
                    });
                } else {
                    return students.filter((student) => {
                        for (const group of student.las_main_group_ids) {
                            if (group === this.mainGroup) {
                                return true;
                            }
                        }
                    });
                }
            }

            return students;
        },
    },
};
</script>

<style scoped lang="scss">
.profiles-apprentice-table ::v-deep {
    .apprentice-table-filters {
        margin-bottom: 0;
        margin-right: map-get($grid-padding-spacing, 'fifteen');

        .search {
            margin-bottom: map-get($grid-padding-spacing, 'fifteen');
        }
    }
}

.group-actions {
    display: flex;
    margin-right: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        font-size: 1.3125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .filters ::v-deep {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .profiles-apprentice-table ::v-deep {
        .apprentice-table-header {
            flex-wrap: wrap;
            flex-direction: row;

            .search {
                margin-bottom: 0;
            }

            .apprentice-table-filters {
                flex: 0 0 auto;
            }
        }

        .options {
            flex: auto;
            flex-grow: 0;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }
}
</style>
